import * as angular from "angular";
import { IRootScope } from "@models";
import { NgInterceptor } from "@app/di/decorators";
import { Token } from "@app/di/token";

@NgInterceptor({
    token: Token.ErrorInterceptor,
    dependencies: [
        Token.$Injector,
        Token.$RootScope,
        Token.$Q,
    ]
})
export class ErrorInterceptor {
    constructor(
        private $injector: ng.auto.IInjectorService,
        private $rootScope: IRootScope,
        private $q: ng.IQService
    ) {

        return {
                response: response => {
                    return response;
                },
                responseError: response => {
                    let $http: ng.IHttpService = $injector.get("$http");
                    let config = response.config;
                    if (!config.ignoreErrors) {
                        switch (response.status) {
                            case 400:
                            case 401:
                            case 0:
                                break;

                            default:
                                let msg: string;
                                msg = "status: " + response.status + "\n";
                                msg += "data: \n" + angular.toJson(response.data);

                                alert(msg);
                                break;
                        }
                    }
                    return $q.reject(response);
                }
            } as any;
    }
}
